import { Injectable } from '@angular/core';
import { compareAsc } from 'date-fns';
import { CalendarDate, CartRow } from 'gung-standard';
import { JeevesDeliveryDateService } from 'gung-standard-jeeves';
import { first, forkJoin, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CultDeliveryDateService extends JeevesDeliveryDateService {
  protected filterDeliveryDatesBySelectedFlow(calendarDates: CalendarDate[]): Observable<CalendarDate[]> {
    return this.gungFlowService.getSelectedFlow().pipe(
      first(),
      switchMap(selectedFlow => this.gungFlowService.getGungFlow(selectedFlow.id)),
      map(flow => {
        if (!flow.isReturnOrder) {
          let indexStop = undefined;
          for (let index = 0; index < calendarDates.length; index++) {
            const date = calendarDates[index];
            if (!!date.valid && indexStop === undefined) {
              indexStop = index + 1;
            }

            if (date.valid && indexStop !== undefined) {
              date.valid = false;
            } else if(indexStop !== undefined) {
              indexStop++;
            }

            if (indexStop !== undefined && indexStop <= index) {
              break;
            }
          }
        }

        if (!!flow.deliveryStartDate && !!flow.deliveryEndDate) {
          const deliveryStartDateValue = new Date(flow.deliveryStartDate);
          const deliveryEndDateValue = new Date(flow.deliveryEndDate);

          return calendarDates.filter(
            calendarDate =>
              compareAsc(calendarDate.date, deliveryStartDateValue) >= 0 &&
              compareAsc(calendarDate.date, deliveryEndDateValue) <= 0
          );
        }

        if (!!flow.deliveryStartDate) {
          const deliveryStartDateValue = new Date(flow.deliveryStartDate);
          return calendarDates.filter(calendarDate => compareAsc(calendarDate.date, deliveryStartDateValue) >= 0);
        }

        if (!!flow.deliveryEndDate) {
          const deliveryEndDateValue = new Date(flow.deliveryEndDate);
          return calendarDates.filter(calendarDate => compareAsc(calendarDate.date, deliveryEndDateValue) <= 0);
        }

        return calendarDates;
      })
    );
  }
}
